export const UserStatus = {
	offline: 'offline',
	online: 'online',
	mobileOnline: 'mobile-online',
	away: 'away',
	idle: 'idle',
	dnd: 'dnd',
	break: 'break'
};

export const UserExternalType = {
	default: 'default',
	bot: 'bot',
	call: 'call'
};